import React, { useEffect, useState } from "react";
import Select from "react-select";
import ApiCustom from "../utils/ApiCustom";

const ReferrerParnerSelection = ({ value, onChange, error }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchApprovedCompanies = async () => {
    setLoading(true);
    try {
      const res = await ApiCustom.get("/company-approved");
      const companies = res?.data?.data?.data?.users || [];

      const referrerList = companies.flatMap((company) =>
        (company.users || [])
          .filter((user) => user.CompaniesHasUsers?.isUserRepresentOfCompany)
          .map((user) => ({
            label: `${user.userFullName} (${company.companyName})`,
            value: user.id,
            user,
            company: {
              id: company.id,
              name: company.companyName,
            },
          })),
      );

      setOptions(referrerList);
    } catch (err) {
      console.error("Lỗi khi lấy người giới thiệu:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApprovedCompanies();
  }, []);

  return (
    <div className="form-control">
      <label className="text-sm mb-1">
        Người giới thiệu <span className="italic">(Nếu có)</span>
      </label>
      <Select
        isClearable
        isLoading={loading}
        options={options}
        value={value ? options.find((opt) => opt.value === value?.value) : null}
        onChange={(selected) => {
          console.log(selected);
          onChange(selected || null);
        }}
        noOptionsMessage={() => "Không có lựa chọn"}
        placeholder="Chọn"
        className={error ? "border border-red-500 rounded" : ""}
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "8px",
            padding: "4px",
            borderColor: error ? "#f87171" : "#d1d5db",
            boxShadow: "none",
            "&:hover": {
              borderColor: "rgb(209 213 219)",
            },
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: "300px",
            overflowY: "auto",
          }),
        }}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default ReferrerParnerSelection;
